import * as Sentry from '@sentry/react';
import { getAppSettings } from './config/appSettings';

export function initSentry(): void {
  const { sentry } = getAppSettings();

  if (!sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: sentry.tracesSampleRate ?? 0,
    sendDefaultPii: false,
    release: sentry.release,
  });
}

export { Sentry };
